exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transaction-document-panel[data-v-43eb83c7]{display:flex;flex-direction:column;height:clamp(23rem,calc(60vh - 5rem),37rem);min-height:0;overflow:hidden;border:1px solid #d1d5db;border-radius:.5rem;background:#fff}", ""]);

// exports
